<div class="search"
    [ngClass]="{'search--dark': themeType === searchThemeEnum.Dark, 'search--light': themeType === searchThemeEnum.Light, 'search-has-focus': hasFocus}">

    <!-- loading -->
    <!-- <img *ngIf="loading === true" class="search__loader" src="/assets/img/loader.gif" /> -->

    <!-- not loading -->
    <span *ngIf="!control.value; else searching" class="search__loupe"></span>
    <!-- <span *ngIf="!loading && control.value" class="search__enter"></span> -->

    <ng-template #searching>
        <div class="search__clear-container" *ngIf="themeType !== searchThemeEnum.Dark">
            <!-- <a *ngIf="control.value" class="search__clear" (click)="onClear()">x</a> -->
            <button *ngIf="control.value" class="search__clear" (click)="onClear()">
                <span>x</span>
            </button>
        </div>
    </ng-template>

    <!-- input and clear phrase button -->
    <input type="text" class="search__input" [formControl]="$any(control)" placeholder="{{'labels.search' | translate | titlecase}}" autofocus
        (focus)="onFocus()" (blur)="onBlur()" #searchInput />
</div>
